import {
  FieldDefinition,
  FieldBuilder,
  MenuCategories,
  MenuSubcategories,
  MENU_CATEGORY_KEY,
  MENU_SUBCATEGORY_KEY,
  MENU_NAME_SUFFIX,
} from '@zendra/shared';
import {
  DestinyService,
  InternalOrderService,
  LocationService,
  SeasonTypeService,
  StrategicCommercialZoneService,
  TransportAccessTypeService,
  VendorService,
  ZoneService,
} from 'cbd-proxies';
import { PropertyOriginDestination } from '../property-origin-destination/property-origin-destination';

FieldBuilder.setNamespace('Planning');

export const PROPERTY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Property.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('propertyCode', 'Entity.Property.PropertyCode')
    .minLength(1)
    .maxLength(4)
    .build(),
  FieldBuilder
    .foreignKey('internalOrderId', 'Entity.Property.InternalOrder', InternalOrderService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .number('fomentContractId', 'Entity.Property.FomentContract')
    .min(1)
    .build(),
  FieldBuilder
    .number('commercialAgentId', 'Entity.Property.CommercialAgent')
    .build(),
  FieldBuilder
    .text('remsoft', 'Entity.Property.RemSoft')
    .maxLength(200)
    .build(),
  FieldBuilder
    .checkbox('isDisabled', 'Entity.Property.IsDisabled')
    .build(),
  FieldBuilder
    .foreignKey('transportAccessTypeId', 'Entity.Property.TransportAccessType', TransportAccessTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('seasonTypeId', 'Entity.Property.SeasonType', SeasonTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .required()
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder
    .foreignKey('destinyId', 'Entity.Destiny', DestinyService)
    .displayFromNested('destiny.name')
    .sortBy('destiny.name')
    .build(),
  FieldBuilder
    .foreignKey('strategicCommercialZoneId', 'Entity.StrategicCommercialZone', StrategicCommercialZoneService)
    .displayFromNested('strategicCommercialZone.name')
    .sortBy('strategicCommercialZone.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .display('fantasyName')
    .keyField('id')
    .build(),
];

export const PROPERTY_CONFIG = {
  entityName: 'Property',
  localizationKey: 'Planning::Entity.Property',
  permission: 'PlanningLocation.Properties',
  fields: PROPERTY_FIELDS,
  children: [
    {
      entityName: 'PropertyOriginDestination',
      foreignKeyField: 'propertyLocationId',
      parentKeyField: 'locationId',
      localizationKey: 'Geographic::Entity.PropertyOriginDestination',
      component: PropertyOriginDestination,
    },
  ],
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.TablesPlanning + MENU_NAME_SUFFIX,
};
